<div class="container" id="main-content" aria-label="Main Content">

    <div>
        <div>
            <h1 tabindex="0" class="heading-title">{{'PAYMENT.TITLE' | translate}}</h1>
            <hr />
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <button class="btn btn-primary cancel-btn" (click)="cancel()"
            tabindex="0">{{'COMMON.CANCEL' | translate}}</button>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <app-elavon-hpp [currency]="currency" [amount]="amount" [orderId]="orderId" [email]="clientEmail"></app-elavon-hpp>
        </div>
    </div>
</div>